import * as React from "react";
const SvgFiRrEmployeesWomanMan = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-employees-woman-man_svg__a)">
      <path
        fill="#062147"
        d="M7.752 17.084a1 1 0 1 1-1.504 1.318l-2.043-2.33c-.083-.095-.23-.125-.308-.063C2.759 16.902 2 17.922 2 20v3a1 1 0 0 1-2 0v-3c0-3.082 1.423-4.593 2.664-5.565.92-.72 2.256-.579 3.045.319zM4.139 6.991c.014 0 .027 0 0 0m17.168 7.421c-.926-.719-2.264-.568-3.047.34l-1.266 1.468-1.285-1.466c-.789-.898-2.125-1.039-3.045-.319C11.424 15.407 10 16.918 10 20v3a1 1 0 0 0 2 0v-3c0-2.078.759-3.098 1.897-3.991.078-.061.224-.031.308.063l2.043 2.33a1 1 0 0 0 .752.341h.004c.29 0 .564-.127.753-.347l2.017-2.338c.082-.095.228-.128.308-.066.997.773 1.918 1.793 1.918 4.007v3a1 1 0 0 0 2 0v-3c0-3.102-1.439-4.615-2.693-5.587M9.98 10.701a1 1 0 0 1-.782 1.178 5.998 5.998 0 0 1-6.321-2.772c-.309 1.397-.64 2.907-.9 4.104a1 1 0 0 1-1.954-.424c.282-1.299 1.701-7.807 1.876-8.351A6.395 6.395 0 0 1 8 0c1.75 0 3.391.718 4.587 1.949A5.98 5.98 0 0 1 17 0c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6c0-.818.166-1.597.463-2.308a4.4 4.4 0 0 0-.941-.899 6.67 6.67 0 0 1-2.67 3.187c-1.081.674-2.469 1.011-3.713 1.011-.028 0-.014 0 0 0 .444 1.724 1.999 3.008 3.86 3.008.269 0 .539-.027.802-.08a1 1 0 0 1 1.179.782M13 5.999c0 2.206 1.794 4 4 4s4-1.794 4-4-1.794-4-4-4-4 1.794-4 4M3.842 4.957a4.67 4.67 0 0 0 2.952-.675 4.68 4.68 0 0 0 1.862-2.228A4.5 4.5 0 0 0 8 2a4.39 4.39 0 0 0-4.158 2.958z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-employees-woman-man_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrEmployeesWomanMan;
